<div class="padding">
  <div>
    <div class="header">{{ 'add_membership' | translate }}</div>
  </div>
  <div>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form (ngSubmit)="addMembership()" #form="ngForm" novalidate>
    <div class="flexColumn">

      <mat-form-field appearance="fill">
        <mat-label>{{ 'member' | translate }}</mat-label>
        <input type="email" rows="3" name="member_email" matInput #member_email="ngModel" placeholder="member email_id"
          email required [(ngModel)]="member.name" maxlength="50">
        <mat-hint>{{member.name == null ? 0 : member.name?.length}}/50 Characters</mat-hint>
        <mat-error *ngIf="member_email.hasError('required')">{{ 'email_required' | translate }}</mat-error>
        <mat-error *ngIf="member_email.hasError('email')">{{ 'email_valid' | translate }}</mat-error>
      </mat-form-field>

      <div class="saveRow">
        <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate
          }}</button>
      </div>

    </div>
  </form>

</div>